import { useState, useEffect } from 'react';

import ReactSelect, { components } from "react-select";

export function Select({prefix, options, placeholder, handleFilter, order, orderName}) {
    
    return (        
 
        <ReactSelect className="filter_status" classNamePrefix="select" 
            onChange={handleFilter}
            options={options}
            placeholder={placeholder}
            components={{
                value: 'Oldest',
                SingleValue: ({ children, ...props }) => {
                return (
                    <components.SingleValue {...props}>
                    <span>{prefix + ": "}</span> {children}
                    </components.SingleValue>
                );
                },
                Placeholder: ({ children, ...props }) => {
                return (
                    <components.Placeholder {...props}>
                    <span>{prefix + ": "}</span> {children}
                    </components.Placeholder>
                );
                },
                IndicatorSeparator: () => null,
            }}
        />
        
    )
}

export function Sort({name, image, sort, order, value}) {

    const [sortDirection, setSortDirection] = useState('');

    const toggle = (event) => {

        let direction = '';
        switch (sortDirection){
            case 'desc':
                direction = 'asc';
                break;
            default:
                direction = 'desc';
        }
        setSortDirection(direction);

        sort(value, direction, name);
    }
    useEffect(() => {

         if (order != value){
             setSortDirection('');
         }

    }, [order]);

    return (

    <>
        <div className={"sort_column " + sortDirection} onClick={toggle}>
            <img src={image} alt="" />
            {name}
        </div>
    </>

    )  
}

export function BarChart({data, height}) {    
    
    const max = Math.max(...data.map(o => o.value))
    
    return (
        
        <div className="barChart">
            {
                data.map((item, index) => (
                    
                    <div className="item" key={index}>
                        <div className="rectangle" data-tooltip={item.value} style={{height: (((item.value*(height-16))/max)+16)+'px'}}/>
                        <div className="legend">{item.name}</div>                                                                                        
                    </div>
                    
                ))
            }
    
       </div>
        
    )
        
}

export function Checkbox({label, register, name, email}) {
    const [isChecked, setIsChecked] = useState(false);
    return (
        <label>
            <input type="checkbox" onClick={() => { setIsChecked(!isChecked); }} {...register(name, {})} />
            <span className={`checkbox ${isChecked ? "checkbox--active" : ""}`} aria-hidden="true" />
            {label} <span className="email">{email}</span>
        </label>
    );
}

export function CheckboxPhone({label, register, name, phone}) {
    const [isChecked, setIsChecked] = useState(false);
    return (
        <label>
            <input type="checkbox" onClick={() => { setIsChecked(!isChecked); }} {...register(name, {})} />
            <span className={`checkbox ${isChecked ? "checkbox--active" : ""}`} aria-hidden="true" />
            {label} <span className="email">{phone}</span>
        </label>
    );
}
